import CONSTANTS from "../../assets/js/Constants"

// import { createBrowserHistory } from 'history'

// const history = createBrowserHistory({
//     forceRefresh: true, // Set true to force full page refreshes
// })

const baoTriPhuongTien = {
   danhSachNhaCungCap: [],
   danhSachViecBaoTri: [],
   thongTinBaoTri: []
}
export default function (state = baoTriPhuongTien, { type, payload }) {
   switch (type) {
      case CONSTANTS.ACTION.BAO_TRI_PHUONG_TIEN.SET_BAO_TRI_PHUONG_TIEN_BY_NCC:
         return { ...state, danhSachNhaCungCap: payload }
      case CONSTANTS.ACTION.BAO_TRI_PHUONG_TIEN.SET_BAO_TRI_PHUONG_TIEN_BY_DS_VIEC:
         return { ...state, danhSachViecBaoTri: payload }
      case CONSTANTS.ACTION.BAO_TRI_PHUONG_TIEN.SET_BAO_TRI_PHUONG_TIEN_BY_ID:
         return { ...state, thongTinBaoTri: payload }

      default:
         return { ...state }
   }
}
